import { type FC } from 'react';
import { type FacilitiesIconProps } from './types';

const Dining: FC<FacilitiesIconProps> = ({ width, height, fill }) => (
  <svg
    width={width || '65'}
    height={height || '65'}
    viewBox="0 0 65 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.9588 12.2314C42.0745 12.2314 43.1902 12.2314 44.3059 12.2314C44.3059 25.5136 44.3059 38.7427 44.3059 51.9717C44.3059 52.9812 42.8183 52.9812 42.8183 51.9717V36.6175C41.6495 36.6175 40.5338 36.6175 39.3649 36.6175C39.0462 36.6706 38.7274 36.6175 38.4086 36.4581C35.9647 35.5549 35.8053 31.1984 35.8053 29.0201C35.8053 27.3731 35.9116 25.5667 36.1772 23.9198C36.7085 20.6258 37.7711 17.3849 38.7274 14.1972C38.993 13.1878 39.8431 12.2314 40.9588 12.2314ZM22.1819 13.0815V20.6789C22.1819 22.6447 23.7758 24.2385 25.7416 24.2385C27.7073 24.2385 29.3543 22.6447 29.3543 20.6789V13.0815C29.3543 12.0721 30.8419 12.0721 30.8419 13.0815V20.6789C30.8419 23.2291 28.9293 25.3542 26.4854 25.7261V51.9717C26.4854 52.9812 24.9978 52.9812 24.9978 51.9717V25.7261C22.5538 25.3542 20.6943 23.2291 20.6943 20.6789V13.0815C20.6943 12.0721 22.1819 12.0721 22.1819 13.0815ZM27.973 13.0815V20.4133C27.973 21.4227 26.4854 21.4227 26.4854 20.4133V13.0815C26.4854 12.0721 27.973 12.0721 27.973 13.0815ZM25.0509 13.0815V20.4133C25.0509 21.4227 23.5102 21.4227 23.5102 20.4133V13.0815C23.5102 12.0721 25.0509 12.0721 25.0509 13.0815ZM40.9588 13.7722C41.5963 13.7722 42.1808 13.7722 42.8183 13.7722V35.1299C41.6495 35.1299 40.4806 35.1299 39.3649 35.1299C36.8148 35.183 37.1867 27.2137 37.6648 24.1323C38.143 21.0508 39.2587 17.5974 40.1619 14.6222C40.3213 14.1441 40.6932 13.7722 40.9588 13.7722Z"
      fill={fill || '#505050'}
    />
  </svg>
);

export default Dining;
